import { AlertGroup, TAB_ALERTS } from 'app/modules/alerts/core/type';

export const ALERT_TYPES: (keyof AlertGroup)[] = [
  'Rack Failed Connection',
  'Reach Critical Level',
  'Abnormal Consumption',
  'Shelf Expiry',
  'Rogue Device',
];

export const DROPDOWN_BUTTON_TEXT = (tab: TAB_ALERTS) =>
  ({
    [TAB_ALERTS.DEVICE_CONNECTION]: 'Device connection',
    [TAB_ALERTS.ITEM_EXPIRY]: 'Item expiry',
    [TAB_ALERTS.REACH_CRITICAL_LEVEL]: 'Reach critical level',
    [TAB_ALERTS.ABNORMAL_CONSUMPTION]: 'Abnormal consumption',
  }[tab]);

export const DROPDOWN_SELECT_QUERY_KEY = {
  [TAB_ALERTS.DEVICE_CONNECTION]: 'device-connection',
  [TAB_ALERTS.ITEM_EXPIRY]: 'item-expiry',
  [TAB_ALERTS.REACH_CRITICAL_LEVEL]: 'reach-critical-level',
  [TAB_ALERTS.ABNORMAL_CONSUMPTION]: 'abnormal-consumption',
};

export const PAGE_SIZE = 10;
